import { call, put, takeLatest } from 'redux-saga/effects';
import { taskSettingsApi } from '../api/taskSettingsApi';
import * as actions from '../actions/taskSettingsActions';

function* getTaskSettingsSaga() {
    try {
        yield put(actions.setTaskSettingsLoading(true));
        const response = yield call(taskSettingsApi.getAllSettings);
        yield put(actions.getTaskSettingsSuccess(response.data));
    } catch (error) {
        yield put(actions.getTaskSettingsFail(error.response?.data?.message || 'Erreur lors de la récupération des paramètres de tâches'));
    } finally {
        yield put(actions.setTaskSettingsLoading(false));
    }
}

function* createTaskSettingSaga(action) {
    try {
        yield put(actions.setTaskSettingsLoading(true));
        const response = yield call(taskSettingsApi.createSetting, action.payload);
        yield put(actions.createTaskSettingSuccess(response.data));
    } catch (error) {
        yield put(actions.createTaskSettingFail(error.response?.data?.message || 'Erreur lors de la création du paramètre de tâche'));
    } finally {
        yield put(actions.setTaskSettingsLoading(false));
    }
}

function* updateTaskSettingSaga(action) {
    try {
        yield put(actions.setTaskSettingsLoading(true));
        const response = yield call(taskSettingsApi.updateSetting, action.payload.id, action.payload.settingData);
        yield put(actions.updateTaskSettingSuccess(response.data));
    } catch (error) {
        yield put(actions.updateTaskSettingFail(error.response?.data?.message || 'Erreur lors de la mise à jour du paramètre de tâche'));
    } finally {
        yield put(actions.setTaskSettingsLoading(false));
    }
}

function* deleteTaskSettingSaga(action) {
    try {
        yield put(actions.setTaskSettingsLoading(true));
        yield call(taskSettingsApi.deleteSetting, action.payload.id);
        yield put(actions.deleteTaskSettingSuccess(action.payload.id));
    } catch (error) {
        yield put(actions.deleteTaskSettingFail(error.response?.data?.message || 'Erreur lors de la suppression du paramètre de tâche'));
    } finally {
        yield put(actions.setTaskSettingsLoading(false));
    }
}

export function* watchTaskSettings() {
    yield takeLatest(actions.GET_TASK_SETTINGS_REQUEST, getTaskSettingsSaga);
    yield takeLatest(actions.CREATE_TASK_SETTING_REQUEST, createTaskSettingSaga);
    yield takeLatest(actions.UPDATE_TASK_SETTING_REQUEST, updateTaskSettingSaga);
    yield takeLatest(actions.DELETE_TASK_SETTING_REQUEST, deleteTaskSettingSaga);
}
